module.exports = __webpack_public_path__ + "static/img/yg2.95ffdeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/yg2.png
// module id = vTO9
// module chunks = 7